import {useCallback, useRef} from 'react';

import {useStablePanelId} from './../../../components/Panel/PanelIDContext';
import {recordRumAction} from './../../../util/datadog/datadogRum';

// This hook is used to log fallback events for the runs line plot to Datadog. It reports when a fallback occurs, such as when the chart cannot be rendered as intended, along with relevant context like whether the plot is in a report and the stable panel ID. This tracking helps monitor unexpected behavior or degraded user experiences in the line plot feature.

export const useFallbackTracking = ({isInReport}: {isInReport: boolean}) => {
  const stablePanelId = useStablePanelId();
  const lastWarningRef = useRef<string | undefined>(undefined);

  return useCallback(
    (warnings: string) => {
      // Only log when the warning changes from the previous call
      if (lastWarningRef.current === warnings) {
        return;
      }
      lastWarningRef.current = warnings;

      recordRumAction('line plot fallback', {
        fallbackReasons: warnings,
        isInReport,
        stablePanelId,
      });
    },
    [isInReport, stablePanelId]
  );
};
